import { render, staticRenderFns } from "./LugarInstalacionView.vue?vue&type=template&id=23b497be"
import script from "./LugarInstalacionView.vue?vue&type=script&lang=js"
export * from "./LugarInstalacionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports